import { render, staticRenderFns } from "./SupplierStatus.vue?vue&type=template&id=25c48dc2&scoped=true&"
import script from "./SupplierStatus.vue?vue&type=script&lang=js&"
export * from "./SupplierStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c48dc2",
  null
  
)

export default component.exports